import { z } from "zod"
import {
	GetLeadsSummaryResponse,
	ListLeadsResponse,
	UpdateLeadResponse,
} from "@/shared/api/generated/marketing-leads/marketing-leads.zod"
import { validateSuccessResponse } from "@/shared/lib/zod-validation-helpers"

const createValidatedApiSelector =
	<T>(schema: z.ZodType<T>) =>
	(response: unknown): T => {
		const data = validateSuccessResponse(schema, response)
		if (data === null) throw new Error("Unexpected or invalid API response")

		return data
	}

export const selectLeadsData = createValidatedApiSelector(ListLeadsResponse)
export const selectLeadsSummaryData = createValidatedApiSelector(
	GetLeadsSummaryResponse,
)
export const selectUpdatedLeadData =
	createValidatedApiSelector(UpdateLeadResponse)
export const selectLeadsExportData = createValidatedApiSelector(
	z.instanceof(Blob),
)
